import * as React from "react";

const Ranking = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M22.8669 14.9736L13.8575 1.72855C13.651 1.42634 13.3738 1.17908 13.0501 1.00822C12.7264 0.837352 12.3659 0.748047 11.9998 0.748047C11.6338 0.748047 11.2733 0.837352 10.9496 1.00822C10.6258 1.17908 10.3487 1.42634 10.1422 1.72855L1.1328 14.9736C0.958125 15.2303 0.839589 15.5211 0.784939 15.8268C0.730289 16.1325 0.740754 16.4464 0.815652 16.7478C0.890549 17.0492 1.02819 17.3314 1.21959 17.576C1.41099 17.8205 1.65184 18.022 1.9264 18.1671L10.9358 22.9836C11.263 23.159 11.6285 23.2507 11.9998 23.2507C12.3711 23.2507 12.7367 23.159 13.0639 22.9836L22.0733 18.1671C22.3478 18.022 22.5887 17.8205 22.7801 17.576C22.9715 17.3314 23.1091 17.0492 23.184 16.7478C23.2589 16.4464 23.2694 16.1325 23.2147 15.8268C23.1601 15.5211 23.0415 15.2303 22.8669 14.9736ZM2.65155 16.8954C2.55846 16.8451 2.47698 16.7758 2.41238 16.692C2.34778 16.6082 2.3015 16.5117 2.27655 16.4089C2.24872 16.3007 2.24423 16.1878 2.26339 16.0777C2.28254 15.9676 2.3249 15.8629 2.38765 15.7704L10.9058 3.24637C11.008 3.0959 11.2498 3.16574 11.2498 3.34621V20.8775C11.2498 21.154 10.9433 21.3289 10.6934 21.1953L2.65155 16.8954Z"
      fill={props.color || '#5B7B82'}
    />
  </svg>
);

export default Ranking;






